export const SWITCH_SHIPMENT = 'SWITCH_SHIPMENT';
export const NEW_ORDER_SET_PRODUCTS = 'NEW_ORDER_SET_PRODUCTS';
export const NEW_ORDER_RESET_PRODUCTS = 'NEW_ORDER_RESET_PRODUCTS';
